// "use client";

// import * as React from "react";
// import {
//   Grid,
//   Button,
//   Box,
//   Typography,
//   FormControl,
//   TextField,
// } from "@mui/material";
// import { Link } from "react-router-dom";

// const SignUpForm = () => {
//   return (
//     <>
// <Box
//   className="auth-main-wrapper sign-up-area"
//   sx={{
//     py: { xs: "60px", md: "80px", lg: "100px", xl: "135px" },
//   }}
// >
//         <Box
//           sx={{
//             maxWidth: { sm: "500px", md: "1255px" },
//             mx: "auto !important",
//             px: "12px",
//           }}
//         >
//           <Grid
//             container
//             alignItems="center"
//             columnSpacing={{ xs: 1, sm: 2, md: 4, lg: 3 }}
//           >
//             <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 7 }}>
//               <Box
//                 sx={{
//                   display: { xs: "none", md: "block" },
//                 }}
//               >
//                 <img
//                   src="/images/bharatonline.png"
//                   alt="sign-up-image"
//                   width={646}
//                   height={804}
//                   style={{
//                     borderRadius: "24px",
//                   }}
//                 />
//               </Box>
//             </Grid>

//             <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 5 }}>
//               <Box
//                 className="form-content"
//                 sx={{
//                   paddingLeft: { xs: "0", lg: "10px" },
//                 }}
//               >
//                 <Box
//                   className="logo"
//                   sx={{
//                     mb: "23px",
//                   }}
//                 >
//                   <img
//                     src="/images/logo-big.svg"
//                     alt="logo"
//                     width={142}
//                     height={38}
//                   />
//                   <img
//                     src="/images/white-logo.svg"
//                     className="d-none"
//                     alt="logo"
//                     width={142}
//                     height={38}
//                   />
//                 </Box>

//                 <Box
//                   className="title"
//                   sx={{
//                     mb: "23px",
//                   }}
//                 >
//                   <Typography
//                     variant="h1"
//                     className="text-black"
//                     sx={{
//                       fontSize: { xs: "22px", sm: "25px", lg: "28px" },
//                       mb: "7px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Sign up to Trezo Dashboard
//                   </Typography>

//                   <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
//                     Sign up with social account or enter your details
//                   </Typography>
//                 </Box>

//                 <Box
//                   className="with-socials"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-around",
//                     gap: "5px",
//                     mb: "20px",
//                   }}
//                 >
//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/google.svg"
//                       alt="google"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/facebook2.svg"
//                       alt="facebook"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/apple.svg"
//                       alt="apple"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>
//                 </Box>

//                 <Box component="form">
//                   <Box mb="15px">
//                     <FormControl fullWidth>
//                       <Typography
//                         component="label"
//                         sx={{
//                           fontWeight: "500",
//                           fontSize: "14px",
//                           mb: "10px",
//                           display: "block",
//                         }}
//                         className="text-black"
//                       >
//                         Full Name
//                       </Typography>

//                       <TextField
//                         label="Enter your full name"
//                         variant="filled"
//                         id="fullName"
//                         name="fullName"
//                         sx={{
//                           "& .MuiInputBase-root": {
//                             border: "1px solid #D5D9E2",
//                             backgroundColor: "#fff",
//                             borderRadius: "7px",
//                           },
//                           "& .MuiInputBase-root::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
//                             {
//                               border: "none",
//                             },
//                         }}
//                       />
//                     </FormControl>
//                   </Box>

//                   <Box mb="15px">
//                     <FormControl fullWidth>
//                       <Typography
//                         component="label"
//                         sx={{
//                           fontWeight: "500",
//                           fontSize: "14px",
//                           mb: "10px",
//                           display: "block",
//                         }}
//                         className="text-black"
//                       >
//                         Email Address
//                       </Typography>

//                       <TextField
//                         label="example&#64;trezo.com"
//                         variant="filled"
//                         id="email"
//                         name="email"
//                         sx={{
//                           "& .MuiInputBase-root": {
//                             border: "1px solid #D5D9E2",
//                             backgroundColor: "#fff",
//                             borderRadius: "7px",
//                           },
//                           "& .MuiInputBase-root::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
//                             {
//                               border: "none",
//                             },
//                         }}
//                       />
//                     </FormControl>
//                   </Box>

//                   <Box mb="15px">
//                     <FormControl fullWidth>
//                       <Typography
//                         component="label"
//                         sx={{
//                           fontWeight: "500",
//                           fontSize: "14px",
//                           mb: "10px",
//                           display: "block",
//                         }}
//                         className="text-black"
//                       >
//                         Password
//                       </Typography>

//                       <TextField
//                         label="Type Password"
//                         variant="filled"
//                         type="password"
//                         id="password"
//                         name="password"
//                         sx={{
//                           "& .MuiInputBase-root": {
//                             border: "1px solid #D5D9E2",
//                             backgroundColor: "#fff",
//                             borderRadius: "7px",
//                           },
//                           "& .MuiInputBase-root::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
//                             {
//                               border: "none",
//                             },
//                         }}
//                       />
//                     </FormControl>
//                   </Box>

//                   <Box my="25px">
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       sx={{
//                         textTransform: "capitalize",
//                         borderRadius: "6px",
//                         fontWeight: "500",
//                         fontSize: { xs: "13px", sm: "16px" },
//                         padding: { xs: "10px 20px", sm: "10px 24px" },
//                         color: "#fff !important",
//                         boxShadow: "none",
//                         width: "100%",
//                       }}
//                     >
//                       <i className="material-symbols-outlined mr-5">person_4</i>
//                       Sign Up
//                     </Button>
//                   </Box>

//                   <Typography
//                     sx={{
//                       mb: "15px",
//                       lineHeight: "1.8",
//                     }}
//                   >
//                     By confirming your email, you agree to our{" "}
//                     <Link
//                       to="/settings/terms-conditions/"
//                       className="text-black"
//                       style={{ fontWeight: "500" }}
//                     >
//                       Terms of Service
//                     </Link>{" "}
//                     and that you have read and understood our{" "}
//                     <Link
//                       to="/settings/privacy-policy/"
//                       className="text-black"
//                       style={{ fontWeight: "500" }}
//                     >
//                       Privacy Policy
//                     </Link>
//                     .
//                   </Typography>

//                   <Typography
//                     sx={{
//                       mb: "15px",
//                       lineHeight: "1.8",
//                     }}
//                   >
//                     Already have an account.{" "}
//                     <Link
//                       to="/authentication/sign-in/"
//                       className="text-primary"
//                       style={{
//                         fontWeight: "500",
//                       }}
//                     >
//                       Sign In
//                     </Link>
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default SignUpForm;


import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Button, Form, Input, Steps, Checkbox, Upload, Typography, message, Row, Col, Select } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { Controller } from 'react-hook-form'
import { Option } from 'antd/es/mentions'
import { Box } from "@mui/material";

import { getAllCategoryApi, signupapi } from '../../../redux/api/api'
const { Step } = Steps
const { Title, Text } = Typography
const steps = ['Personal & Business Info', 'Upload Documents']

export default function SignUpForm() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm()
  const [current, setCurrent] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [businessTypes, setBusinessTypes] = useState([])
  const [categories, setCategories] = useState([])
  //console.log("categories", categories);

  const navigate = useNavigate()

  const onSubmit = async (data) => {
    //console.log('Form Data:', data)
    // return
    setIsLoading(true)
    try {
      const res = await signupapi(data)
      if (res.status === 200) {
        alert('Registration completed successfully.Please await admin approval.Your login credentials have been sent to your registered email address.')

        navigate('/')
      }
    } catch (err) {
      console.error(err)
      message.error(
        err.response?.data?.message || 'An error occurred while signing up. Please try again.',
      )
    } finally {
      setIsLoading(false)
    }
  }


  const getall_business_type = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/getall_business_type`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      ////console.log("res", res);
      if (res.ok) {
        const data = await res.json();
        setBusinessTypes(data)
        //console.log('Business Types:', data);
      }
    } catch (error) {
      console.error('Error fetching business types:', error);
    }
  }



  const getCategory = async () => {
    try {
      const res = await getAllCategoryApi()
      // Your data is in res.data.info
      if (res.status === 200 && res.data.isSuccess) {
        setCategories(res.data.info)
      }
    } catch (error) {
      console.error('Error fetching categories:', error)
    }
  }
  useEffect(() => {
    getall_business_type();
    getCategory();
  }, []);

  const next = () => setCurrent(current + 1)
  const prev = () => setCurrent(current - 1)

  return (
    <Box
      className="auth-main-wrapper sign-up-area"
      sx={{
        position: "fixed",        // fix it on screen
        top: 0,
        left: 0,
        width: "100vw",           // full screen width
        height: "100vh",          // full screen height
        overflow: "hidden",       // disable scrolling inside the box

        bgcolor: "background.default", // optional: background
      }}
    >

      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F4F6F8',
          padding: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            flexWrap: 'wrap', // allow wrapping on smaller screens
            maxWidth: 1100, // bigger container for form + image
            background: '#fff',
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            overflow: 'hidden',
          }}
        >
          <div style={{ flex: '1 1 300px', background: '#f0f2f5', minHeight: 500 }}>
            <img
              src="/images/bharatonline.png"
              alt="Register Illustration"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
          <div style={{ flex: '1 1 400px', padding: 24, minWidth: 300 }}>
            <Title level={3} style={{ textAlign: 'center' }}>
              Register as Admin
            </Title>
            <Text
              type="secondary"
              style={{
                display: 'block',
                textAlign: 'center',
                marginBottom: 24,
              }}
            >
              Welcome to Bharat Online
            </Text>
            <Steps current={current} style={{ marginBottom: 24 }}>
              {steps.map((label) => (
                <Step key={label} title={label} />
              ))}
            </Steps>

            <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
              {current === 0 && (

                <>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Controller
                        name="firstName"
                        control={control}
                        rules={{ required: 'First Name is required' }}
                        render={({ field }) => (
                          <Form.Item
                            label="First Name"
                            validateStatus={errors.firstName ? 'error' : ''}
                            help={errors.firstName?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>

                    <Col span={12}>
                      <Controller
                        name="lastName"
                        control={control}
                        rules={{ required: 'Last Name is required' }}
                        render={({ field }) => (
                          <Form.Item
                            label="Last Name"
                            validateStatus={errors.lastName ? 'error' : ''}
                            help={errors.lastName?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Controller
                        name="mobileNo"
                        control={control}
                        rules={{
                          required: 'Mobile Number is required',
                          pattern: { value: /^[0-9]{10}$/, message: 'Enter a valid 10-digit number' },
                        }}
                        render={({ field }) => (
                          <Form.Item
                            label="Mobile Number"
                            validateStatus={errors.mobileNo ? 'error' : ''}
                            help={errors.mobileNo?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>

                    <Col span={12}>
                      <Controller
                        name="emailId"
                        control={control}
                        rules={{
                          required: 'Email Id is required',
                          pattern: { value: /^\S+@\S+$/i, message: 'Enter a valid email' },
                        }}
                        render={({ field }) => (
                          <Form.Item
                            label="Email Id"
                            validateStatus={errors.emailId ? 'error' : ''}
                            help={errors.emailId?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Controller
                        name="businessName"
                        control={control}
                        rules={{ required: 'Business Name is required' }}
                        render={({ field }) => (
                          <Form.Item
                            label="Business Name"
                            validateStatus={errors.businessName ? 'error' : ' '}
                            help={errors.businessName?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>
                    {/* <Col span={12}>
                    <Controller
                      name="businessType"
                      control={control}
                      rules={{ required: 'Business Type is required' }}
                      render={({ field }) => (
                        <Form.Item
                          label="Business Type"
                          validateStatus={errors.businessType ? 'error' : ''}
                          help={errors.businessType?.message}
                        >
                          <Select
                            {...field}
                            placeholder="Select Business Type"
                            onChange={(value) => field.onChange(value)} // needed for react-hook-form
                            allowClear
                          >
                            {businessTypes.map((type) => (
                              <Option key={type._id} value={type.title || type.businessType}>
                                {type.title || type.businessType}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                    />
                  </Col> */}
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Controller
                        name="category"
                        control={control}
                        rules={{ required: 'Category is required' }}
                        render={({ field }) => (
                          <Form.Item
                            label="Category"
                            validateStatus={errors.category ? 'error' : ''}
                            help={errors.category?.message}
                          >
                            <Select
                              {...field}
                              placeholder="Select Category"
                              onChange={(value) => field.onChange(value)}
                              allowClear
                            >
                              {categories.map((cat) => (
                                <Option key={cat._id} value={cat.name || cat.category_name}>
                                  {cat.name || cat.category_name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        )}
                      />
                    </Col>
                    <Col span={12}>
                      <Controller
                        name="subCategory"
                        control={control}
                        rules={{ required: 'Sub Category is required' }}
                        render={({ field }) => (
                          <Form.Item
                            label="Sub Category"
                            validateStatus={errors.subCategory ? 'error' : ''}
                            help={errors.subCategory?.message}
                          >
                            <Input {...field} />
                          </Form.Item>
                        )}
                      />
                    </Col>
                  </Row>
                  <Form.Item style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                    <Button type="primary" onClick={handleSubmit(() => setCurrent(current + 1))}>
                      Next
                    </Button>
                  </Form.Item>
                </>
              )}
              {current === 1 && (
                <>
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Upload Identity Proof"
                        validateStatus={errors.idProof ? 'error' : ''}
                        help={errors.idProof?.message}
                      >
                        <Upload
                          beforeUpload={() => false}
                          {...register('idProof')}
                          listType="text"
                          maxCount={1}
                        >
                          <Button icon={<UploadOutlined />} type="dashed" block>
                            Select Identity Proof
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Upload Residential Proof"
                        validateStatus={errors.residentialProof ? 'error' : ''}
                        help={errors.residentialProof?.message}
                      >
                        <Upload
                          beforeUpload={() => false}
                          {...register('residentialProof')}
                          listType="text"
                          maxCount={1}
                        >
                          <Button icon={<UploadOutlined />} type="dashed" block>
                            Select Residential Proof
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    validateStatus={errors.terms ? 'error' : ''}
                    help={errors.terms?.message}
                  >
                    <Controller
                      name="terms"
                      control={control} // get it from useForm()
                      rules={{ required: 'You must agree to the terms' }}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value} // important: bind checked value
                        >
                          I agree to Terms and Conditions
                        </Checkbox>
                      )}
                    />
                  </Form.Item>
                  <Form.Item style={{ marginTop: 30 }}>
                    <Row gutter={16} justify="space-between">
                      <Col xs={24} sm={10}>
                        <Button block onClick={prev}>
                          Back
                        </Button>
                      </Col>
                      <Col xs={24} sm={10}>
                        <Button type="primary" htmlType="submit" block loading={isLoading}>
                          Register
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>

                  <div style={{ textAlign: 'center', marginTop: 32 }}>
                    <Text type="secondary">
                      Already registered?{' '}
                      <span
                        style={{ color: '#1890ff', cursor: 'pointer', fontWeight: 500 }}
                        onClick={() => navigate('/')}
                      >
                        Sign In
                      </span>
                    </Text>
                  </div>
                </>
              )}
            </Form>
          </div>
        </div>
      </div>
    </Box>
  )
}
